import React , {useState} from 'react';
import FieldSelect from '../fields/FieldSelect';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import { getFieldStatusProps } from '../../selectors/defaultSelectors';
import FieldCustomSelect from '../fields/FieldCustomSelect';
import ReactLoading from 'react-loading';
import Select, { components } from 'react-select';
const FORM_LABEL = {
    DispatchLocationID: getTranslation('FIELD.DISPATCH_LOCATION'),
};
const DropdownIndicator = (props) => {
    const { indicatorText } = props.selectProps;
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                {indicatorText}
            </components.DropdownIndicator>
        )
    );
};

const Option = (props) => {
    const { data } = props;
    let { className } = props;

    if (typeof data.className != 'undefined') {
        className += ' ' + data.className;
    }
  
    return (
        components.Option && (
            <components.Option {...props}   className={className}  />
        )
    );
};
function CheckoutDispatchLocation(props) {
    const {
        isLoading,
        fieldStatus,
        handleFormUpdate,
        dispatchLocations,
        formData,
        handleFormUpdateDispatchLocation,
        requestDisPatchLocationFilter,
        fieldRefs,
    } = props;
    console.log('loading---holder',isLoading)
    const [limit, setLimit] = useState(5);
    const [inputValue, setInputValue] = useState('');
    let availableAddressesSelect = [
        ...dispatchLocations.map((item) => {
            return {
                label: item.Address.FullAddress,
                value: item.ID,
            };
        }),
    ];
    const debounce = (func, wait) => {
        let timeout;
        return function(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    };
    const handleDebouncedInputChange = debounce((value) => {
        setInputValue(value);
        handleInputChange(value);
     
    }, 1000);

    // handle input change event
    const handleInputChange = (value) => {
        requestDisPatchLocationFilter(5, value).then((results) => {
        });
    };
    const findBusinessNameById = (id) => {
        const numericId = Number(id);
        const business = availableAddressesSelect.find(
            (business) => business.value == numericId
        );
        return business ? business.label : 'Select Dispatch Locations';
    };
    const IndicatorsContainer = (props) => {
        const { limit, value, isMulti } = props.selectProps;
    
        if (isMulti && (typeof value == 'Array' && value.length >= limit))
            return null;
        return <components.IndicatorsContainer  onClick={findBusinessNameById('')} {...props} />;
    };      
    
    const selectedInputValue = findBusinessNameById(formData.DispatchLocationID  );
    console.log(
        'selectedInputValuebilling',isLoading
    )
    
    const renderLoading = () => {
        if (!isLoading) return null;
        return (
            <ReactLoading
                type='spin'
                color='black'
                height={20}
                width={20}
                className='button__spinner'
            />
        );
    };
    return (
        <React.Fragment>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <i className='icon icon-business' />
                    </span>
                </span>

                <h5 className='heading--lv5 heading'>
                    <LocalizedMessage
                        id={'CHECKOUT.DISPATCH_LOCATION.HEADING'}
                    />
                </h5>
            </div>
            <div className='card__content'>
                {/* <div className='form__highlight all-options'>
                    <FieldCustomSelect
                        isLoading={isLoading}
                        isSearchable = {true}
                        isClearable = {true}
                        label={FORM_LABEL['DispatchLocationID']}
                        animatedLabel={FORM_LABEL['DispatchLocationID']}
                        name='DispatchLocationID'
                        options={availableAddressesSelect}
                        value={formData.DispatchLocationID || 0}
                        onChange={handleFormUpdate}
                        {...getFieldStatusProps(fieldStatus, 'DispatchLocationID')}
                    />
                </div> */}
                <div className='form__highlight all-options'>
                    <div className='field field--filled'>
                        <Select
                            ref={(r) =>
                                (fieldRefs.DispatchLocationID = r)
                            }
                            required
                            fieldClasses='field__input'
                            className='react-select__container'
                            classNamePrefix='react-select'
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                            limit={1}
                            // end custom props
                            components={{
                                IndicatorsContainer,
                                // DropdownIndicator,
                                // Option,
                            }}
                            indicatorText={''}
                            onInputChange={(value, actionMeta) => {
                                if (actionMeta.action === 'input-change') {
                                    handleDebouncedInputChange(value);
                                } else {
                                    // handleDispatchLocationLabel('DispatchLocationLabel', '');
                                }
                            }}
                            
                            isLoading={isLoading}
                            label={FORM_LABEL['DispatchLocationID']}
                            animatedLabel={
                                FORM_LABEL['DispatchLocationID']
                            }
                            name='DispatchLocationID'
                            options={availableAddressesSelect}
                            // onChange={handleFormUpdate}
                            defaultValue={{
                                label:
                                    selectedInputValue ,
                                value:
                                    selectedInputValue ,
                            }}
                            value={{
                                label:
                                    selectedInputValue ,
                            }}
                            onChange={(name, value) => {
                                if (value.action == 'clear') {
                                    requestDisPatchLocationFilter();
                                    handleFormUpdateDispatchLocation(
                                        value.name,
                                        ''
                                    );
                                } else {
                                    handleFormUpdateDispatchLocation(
                                        name,
                                        value
                                    );
                                }
                            }}
                        />
                        {renderLoading()}
                    </div>
                   
                </div>
            </div>
        </React.Fragment>
    );
}

export default CheckoutDispatchLocation;
